// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-check-input:checked {\n  background-color: rgb(0, 176, 240);\n  border-color: rgb(0, 176, 240);\n}\n", "",{"version":3,"sources":["webpack://./src/styles/LoginFormStyle.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,8BAA8B;AAChC","sourcesContent":[".form-check-input:checked {\n  background-color: rgb(0, 176, 240);\n  border-color: rgb(0, 176, 240);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
